import axios from '@/axios'

const state = {
  loadingSpecifiedDate: false,
  loadingCompareAdv: false,
  loadingUseAdvPackage: false,
  loadingOwnerMarketer: false,
  loadingGrowthAdv: false,
  loadingLastDaysAdv: false,
  loadingAdvOwnerMarketer: false,
};

const actions = {
  async save({commit}, payload) {
    try {
      commit('LOADING_SPECIFIED_DATE', true);
      const {data} = await axios.post('admin/adv/query/create',payload);
      return  data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_SPECIFIED_DATE', false);
    }
  },
  async line({commit}, payload) {
    try {
      commit('LOADING_COMPARE_DATE', true);
      const {data} = await axios.post('admin/adv/query/compare',payload);
      return  data;
    } catch (e) {
        throw e;
    } finally {
      commit('LOADING_COMPARE_DATE', false);
    }
  },
  async donut({commit}, payload) {
    try {
      commit('LOADING_USE_ADV_PACKAGE', true);
      const {data} = await axios.post('admin/adv/chart/ipc',payload);
      return  data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_USE_ADV_PACKAGE', false);
    }
  },
  async countAdv({commit}, payload) {
    try {
      commit('LOADING_MARKETER_OWNER', true);
      const {data} = await axios.post('admin/adv/query/city',payload);
      return  data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_MARKETER_OWNER', false);
    }
  },
  async growthAdv({commit}, payload) {
    try {
      commit('LOADING_GROWTH_ADV', true);
      const {data} = await axios.post('admin/adv/chart/growth',payload);
      return  data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_GROWTH_ADV', false);
    }
  },
  async lastDaysAdv({commit}, payload) {
    try {
      commit('LOADING_LAST_DAY_ADV', true);
      const {data} = await axios.post('admin/adv/chart/count',payload);
      return  data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_LAST_DAY_ADV', false);
    }
  },
  async countOwnerMarketer({commit}, payload) {
    try {
      commit('LOADING_OWNER_MARKETER', true);
      const {data} = await axios.post('admin/adv/query/creator',payload);
      return  data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_OWNER_MARKETER', false);
    }
  },
}

const mutations = {
  LOADING_SPECIFIED_DATE(state, payload) {
    state.loadingSpecifiedDate = payload;
  },
  LOADING_COMPARE_DATE(state, payload) {
    state.loadingCompareAdv = payload;
  },
  LOADING_USE_ADV_PACKAGE(state, payload) {
    state.loadingUseAdvPackage = payload;
  },
  LOADING_MARKETER_OWNER(state, payload) {
    state.loadingOwnerMarketer = payload;
  },
  LOADING_GROWTH_ADV(state, payload) {
    state.loadingGrowthAdv = payload;
  },
  LOADING_LAST_DAY_ADV(state, payload) {
    state.loadingLastDaysAdv = payload;
  },
  LOADING_OWNER_MARKETER(state, payload) {
    state.loadingAdvOwnerMarketer = payload;
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
